import React from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import useHomeAddress from "../../Hooks/getHomeAddress";

const ProtectedRoute = ({ children }) => {
  const { homeAddress } = useHomeAddress();
  const location = useLocation();

  const isMobileUserAgent = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  };

  const authUser =
    localStorage.getItem("currentUser") && localStorage.getItem("UserToken");

  if (!authUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // if (!isMobileUserAgent()) {
  //   return <Navigate to={homeAddress} replace />;
  // }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
